<template>
  <div>
    <h3 class="student-subaccount-box--title mb-3">
      {{ $t('archivedClasses') }}
    </h3>

    <v-row class="mb-4">
      <v-col cols="6" lg="3">
        <v-menu v-model="showFromPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="date.from_date_time" v-bind:label="$t('fromDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFilter('from_date_time')" color="success"></v-text-field>
          </template>
          <v-date-picker @change="getRecordings" color="green lighten-1" v-model="date.from_date_time"
            @input="showFromPicker = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="6" lg="3">
        <v-menu v-model="showToPicker" :close-on-content-click="false" :nudge-right="40"
          transition="scale-transition" offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="date.to_date_time" v-bind:label="$t('toDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFilter('to_date_time')" :disabled="!date.from_date_time" color="success"></v-text-field>
          </template>
          <v-date-picker @change="getRecordings" color="green lighten-1" v-model="date.to_date_time"
            @input="showToPicker = false" :allowed-dates="checkAllowedDates"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-data-table :headers="headersTitles" :items="items" class="elevation-1" :items-per-page="limit" item-key="number"
      :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50, 100],
          'show-current-page': true,
					showFirstLastPage: true,
					firstIcon: 'mdi-arrow-collapse-left',
					lastIcon: 'mdi-arrow-collapse-right',
        }" @update:options="onPageChange" 
        mobile-breakpoint="992"
        :server-items-length="totalRecordings">
      <template v-slot:item.action="{ item }">
        <v-btn
        :data-testId="`view-record-btn-${item.number}`"
        class="action-btn"
        color="green lighten-1"
        type="button" 
        small
        shaped
        @click="viewRecording(item.number)">
          {{ $t('viewClass') }}
        </v-btn>
      </template>
      <template v-slot:item.feedback="{ item }">
        <v-btn
          :data-testId="`feedback-btn-${item.number}`"
          class="action-btn"
          color="green lighten-1"
          type="button"
          small
          shaped
          @click="showFeedbackDialog(item)"
          :disabled="!item.isFeedbackEnabled || item.isFeedbackSubmitted"
        >
          {{ $t('feedback') }}
        </v-btn>
      </template>
    </v-data-table>

        <!-- Session record dialog -->
    <v-dialog 
      v-model="recordDialog" 
      max-width="786" 
      transition="scale-transition" 
      @click:outside="closeRecordModal" 
      @keydown.esc="closeRecordModal">
      <v-card class="p-8">
        <v-card-title>
          <h5>Recording Preview</h5>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" small  @click="closeRecordModal">
            <v-icon dark>
              mdi-window-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="p-4 d-flex justify-center">
        <video
          class="video-container" 
          controls 
          preload 
          ref="session_record"
          >
          <source v-bind:src="currentVideoUrl" type="video/mp4">
            Your browser does not support HTML video.
        </video>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Feedback Dialog -->
    <FeedbackModal
    v-if="feedbackDialog"
    :visible="feedbackDialog"
    :session="this.session"
    @hideDialog="hideFeedbackDialog"
  ></FeedbackModal>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import FeedbackModal from "../FeedbackModal.vue";

export default {
  mixins: [GlobalMixin],
  components:{FeedbackModal},
  data() {
    return {
      items: [
      ],
      dataBody: {},
      limit: 10,
      pages: null,
      page: 1,
      pageSize: 2,
      currentVideoUrl: null,
      totalRecordings: null,

      recordDialog: false,
      feedbackDialog : false,
      session: {},
      userType: JSON.parse(localStorage.getItem("vuex")).auth.user.user.user_type,

      showFromPicker: false,
      showToPicker: false,
      date: {},
    }
  },
  methods: {
    viewRecording(sessionId) {
      this.axios.get(`${process.env.VUE_APP_APIEndPoint}reserve/sessions/${sessionId}/`, this.headers)
        .then((res) => {
          if (!res.data.data.record_public_url || res.data.data.record_public_url === "") {
            this.notify(this.$t('recordNotAvailable'), 'error');
          } else {
            this.currentVideoUrl = atob(res.data.data.record_public_url);
            this.recordDialog = true;
          }
        }).catch((error) => {
          let errors = '';
          error.response.data.errors.forEach((value, index) => {
            for (error in value) {
              errors += `<li>${value[error]}</li>`;
            }
          });
          this.setAlert('error', `${this.$t("Oops")}`, errors , 5000)
        });
    },
    async onPageChange({ page }) {
      this.ShowLoading();
      try {
        this.dataBody.session_offset = (page - 1) * this.limit ?? 0;
        this.dataBody.session_limit = this.limit;
        this.dataBody.webinar_offset = (page - 1) * this.limit ?? 0;
        this.dataBody.webinar_limit = this.limit;
        await this.getRecordings();
      } finally {
        this.HideLoading();
      }
    },
    getRecordings() {
      const {from_date_time, to_date_time} = this.date;
      const body = {
        ...this.dataBody,
      }
      if (from_date_time) body.from_date_time = `${from_date_time} 00:00:00`;
      if (to_date_time) body.to_date_time = `${to_date_time} 00:00:00`;
      this.axios.post(`${process.env.VUE_APP_APIEndPoint}reserve/sessions-webinars-list/`, body, this.headers)
        .then((res) => {
          this.totalRecordings = res.data.data.sessions_pagination_data.count
          this.pages = Math.ceil(res.data.data.sessions_pagination_data.count / res.data.data.sessions_pagination_data.limit);
          this.items = res.data.data.upcoming_sessions.map(session => {
            return {
              number: session.group_session_id || session.session_id,
              date: session.start_date,
              tutorName: `${session.tutor.first_name} ${session.tutor.last_name}`,
              courseType: session.course_type,
              program: session.program.name,
              costusd: session.session_fee,
              isFeedbackEnabled: session.is_feedback_enabled,
              isFeedbackSubmitted: this.userType === "student" ? session.is_student_feedback_submitted : session.is_tutor_feedback_submitted,
            }
          });
        }).catch((error) => {
          let errors = '';
          error.response.data.errors.forEach((value, index) => {
            for (error in value) {
              errors += `<li>${value[error]}</li>`;
            }
          });
          this.setAlert('error', `${this.$t("Oops")}`, errors , 5000)
        });
    },
    
    closeRecordModal() {
      this.recordDialog = false
      this.$refs.session_record.pause()
    },

    showFeedbackDialog(item) {
      this.feedbackDialog = true,
      this.session = item;
    },

    hideFeedbackDialog($event) {
      this.feedbackDialog = $event
      this.getRecordings();
    },
    checkAllowedDates(date) {
      return date >= this.date.from_date_time;
    },
    clearFilter(type) {
      delete this.date[type];
      this.getRecordings();
    },
  },
  computed: {
    headersTitles() {
      return [
        { text: "#", value: "number", sortable: false, align:'center' },
        { text: this.$t("Date"), value: "date", sortable: false, align:'center' },
        { text: this.$t("tutorName"), value: "tutorName", sortable: false, align:'center' },
        { text: this.$t("Course Type"), value: "courseType", sortable: false, align:'center' },
        { text: this.$t("Program"), value: "program", sortable: false, align:'center' },
        { text: this.$t("totalCost"), value: "costusd", sortable: false, align:'center' },
        { text: "Records", value: "action", sortable: false, align:'center' },
        { text: this.$t("feedback"), value: "feedback", sortable: false, align: "center" }
      ]
    }
  }
}

</script>
<style scoped lang="scss">
.action-btn{
  color: #fff
}
.video-container {
  width: 100%;
}
</style>
<style>
video {

  width: 100%;
}
</style>